import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, MenuItem, Checkbox, FormControlLabel, Typography, IconButton, Box, CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Autocomplete from '@mui/material/Autocomplete';
// import OlaMaps from '../../common/components/OlaMaps';
// import LocationOnIcon from '@mui/icons-material/LocationOn';

const LOCATION_OPTIONS = [
  "Rachenahalli 1",
  "Rachenahalli 2",
  "Rachenahalli 3",
  "HegdeNagar 1",
  "HegdeNagar 2",
  "Bharatiya City 1",
  "Bharatiya City 2",
  "Bharatiya City 3",
  "Kannur 1",
  "Kannur 2",
  "Kannur 3",
  "WebCity 1",
  "WebCity 2",
  "Kothanur 1",
  "Kothanur 2",
  "Kothanur- Narayanpura 1",
  "Kothanur- Narayanpura 2",
  "Kothanur- Narayanpura 3",
  "Byrathi 1",
  "Hennur Main Road 1",
  "Hennur Cross 1",
  "Ashwath nagar 1"
];

const TYPE_OPTIONS = [
  "Agent",
  "Super Agent",
  "Individual",
  "Part of Agent",
  "Part of Super Agent",
  "In House"
];

const WORK_TYPE_OPTIONS = [
  "parttime",
  "fulltime"
];

const WEEKOFF_OPTIONS = [
  "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
];

const SUV_PRICE_LABELS = [
  "E3 I4",
  "E2 I4",
  "E1 I4",
  "E3 I2",
  "E2 I2",
  "E1 I2",
  "E3 I1",
  "E2 I1",
  "E1 I1"
];

const HATCHBACK_PRICE_LABELS = [
  "E3 I4",
  "E2 I4",
  "E1 I4",
  "E3 I2",
  "E2 I2",
  "E1 I2",
  "E3 I1",
  "E2 I1",
  "E1 I1"
];

const SEDAN_PRICE_LABELS = [
  "E3 I4",
  "E2 I4",
  "E1 I4",
  "E3 I2",
  "E2 I2",
  "E1 I2",
  "E3 I1",
  "E2 I1",
  "E1 I1"
];

const WasherDialog = ({ open, onClose, onSave, washer }) => {
  const [washerData, setWasherData] = useState({
    name: '',
    phone: '',
    email: '',
    location: '',
    address: '',
    lampNo: '',
    lampIdCard: '',
    googleMapsUrl: '',
    employeeType: '',
    radius: '',
    weekoff: '',
    workType: '',
    subscription: false,
    onDemand: false,
    workingHours: [{ from: '', to: '' }],
    suvPrices: {},
    hatchbackPrices: {},
    sedanPrices: {},
    roles: []
  });
  const [leaderOptions, setLeaderOptions] = useState([]);
  const [agentOptions, setAgentOptions] = useState([]);
  const [leaderLoading, setLeaderLoading] = useState(false);
  const [agentLoading, setAgentLoading] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [radius, setRadius] = useState('');

  useEffect(() => {
    if (washer) {
      setWasherData({
        name: washer.name || '',
        phone: washer.phone || '',
        email: washer.email || '',
        location: washer.location || '',
        address: washer.address || '',
        lampNo: washer.lampNo || '',
        lampIdCard: washer.lampIdCard || '',
        googleMapsUrl: washer.gps?.length ? `https://www.google.com/maps?q=${washer.gps.lat},${washer.gps.lng}` : '',
        employeeType: washer.employeeType || '',
        radius: washer.radius || '',
        weekoff: washer.weekoff || '',
        workType: washer.workType || '',
        subscription: washer.subscription || false,
        onDemand: washer.onDemand || false,
        workingHours: washer.workingHours && washer.workingHours.length > 0 ? washer.workingHours : [{ from: '', to: '' }],
        suvPrices: washer.suvPrices && typeof washer.suvPrices === 'object' && !Array.isArray(washer.suvPrices)
          ? washer.suvPrices
          : {},
        hatchbackPrices: washer.hatchbackPrices && typeof washer.hatchbackPrices === 'object' && !Array.isArray(washer.hatchbackPrices)
          ? washer.hatchbackPrices
          : {},
        sedanPrices: washer.sedanPrices && typeof washer.sedanPrices === 'object' && !Array.isArray(washer.sedanPrices)
          ? washer.sedanPrices
          : {},
        roles: washer.roles || [],
        agentId: washer.agentId || '',
        leaderId: washer.leaderId || ''
      });
      // Fetch and set leader option if leaderId exists
      if (washer.leaderId) {
        fetchWasherOptionsById(washer.leaderId, 'leader', setLeaderOptions);
      }
      // Fetch and set agent option if agentId exists
      if (washer.agentId) {
        fetchWasherOptionsById(washer.agentId, 'agent', setAgentOptions);
      }
    } else {
      setWasherData({
        name: '',
        phone: '',
        email: '',
        location: '',
        address: '',
        lampNo: '',
        lampIdCard: '',
        googleMapsUrl: '',
        employeeType: '',
        radius: '',
        weekoff: '',
        workType: '',
        subscription: false,
        onDemand: false,
        workingHours: [{ from: '', to: '' }],
        suvPrices: {},
        hatchbackPrices: {},
        sedanPrices: {},
        roles: [],
        agentId: '',
        leaderId: ''
      });
    }
  }, [washer, open]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setWasherData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSuvPriceChange = (label, value) => {
    setWasherData(prev => ({
      ...prev,
      suvPrices: { ...prev.suvPrices, [label]: value }
    }));
  };
  const handleHatchbackPriceChange = (label, value) => {
    setWasherData(prev => ({
      ...prev,
      hatchbackPrices: { ...prev.hatchbackPrices, [label]: value }
    }));
  };
  const handleSedanPriceChange = (label, value) => {
    setWasherData(prev => ({
      ...prev,
      sedanPrices: { ...prev.sedanPrices, [label]: value }
    }));
  };

  const handleAvailabilityChange = (idx, field, value) => {
    setWasherData(prev => ({
      ...prev,
      lampAvailability: prev.lampAvailability.map((slot, i) =>
        i === idx ? { ...slot, [field]: value } : slot
      )
    }));
  };

  const handleAddAvailability = () => {
    setWasherData(prev => ({
      ...prev,
      lampAvailability: [...prev.lampAvailability, { from: '', to: '' }]
    }));
  };
  
  function getLatLngFromGoogleMapsUrl(url) {
    const regex = /@([-.\d]+),([-.\d]+)/;
    const match = url.match(regex);

    if (match) {
      const latitude = parseFloat(match[1]);
      const longitude = parseFloat(match[2]);
      return { latitude, longitude };
    } else {
      return null; // No match found
    }
  }

  const handleSubmit = async () => {
    console.log('Washer Data:', washerData);

    function getLatLngFromGoogleMapsUrl(url) {
        const regex = /@([-.\d]+),([-.\d]+)/;
        const match = url.match(regex);

        if (match) {
          const latitude = parseFloat(match[1]);
          const longitude = parseFloat(match[2]);
          return { latitude, longitude };
        } else {
          return null; // No match found
        }
      }

      // Example usage:
    const coords = getLatLngFromGoogleMapsUrl(washerData.googleMapsUrl);
    delete washerData.googleMapsUrl; // Remove the URL after extracting coordinates
    washerData.gps = coords ? {lat: coords.latitude, lng: coords.longitude} : {};

    try {
      const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
      let url = `${process.env.REACT_APP_SERVER_URI}/washers/add`;
      let method = 'POST';
      if (washer && washer._id) {
        url = `${process.env.REACT_APP_SERVER_URI}/washers/update/${washer._id}`;
        method = 'PUT';
      }
      const res = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: token ? `Bearer ${token}` : '',
        },
        body: JSON.stringify(washerData),
      });
      if (!res.ok) throw new Error('Failed to save washer');
      const savedWasher = await res.json();
      if (onSave) onSave(savedWasher);
      // Reset only if adding, not editing
      if (!washer) {
        setWasherData({
          name: '',
          phone: '',
          email: '',
          location: '',
          address: '',
          lampNo: '',
          lampIdCard: '',
          googleMapsUrl: '',
          employeeType: '',
          radius: '',
          weekoff: '',
          workType: '',
          subscription: false,
          onDemand: false,
          workingHours: [{ from: '', to: '' }],
          suvPrices: {},
          hatchbackPrices: {},
          sedanPrices: {},
          roles: [],
          agentId: '',
          leaderId: ''
        });
      }
    } catch (err) {
      console.log(err);
      alert('Failed to save washer');
    }
  };

  // Fetch leaders or agents from backend
  const fetchWasherOptions = async (search, role, setOptions, setLoading) => {
    setLoading(true);
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    try {
      const res = await fetch(
        `${process.env.REACT_APP_SERVER_URI}/washers/options?search=${encodeURIComponent(search)}&role=${role}`,
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );
      const data = await res.json();
      setOptions(Array.isArray(data) ? data : []);
    } catch {
      setOptions([]);
    }
    setLoading(false);
  };

  // Fetch a washer by id and set as option for Autocomplete
  const fetchWasherOptionsById = async (id, role, setOptions) => {
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    try {
      const res = await fetch(
        `${process.env.REACT_APP_SERVER_URI}/washers/options?id=${id}&role=${role}`,
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );
      const data = await res.json();
      setOptions(Array.isArray(data) ? data : []);
    } catch {
      setOptions([]);
    }
  };

  // LocationPicker: button + optional radius input that opens OlaMaps modal and returns selection
  function LocationPicker({ selected, onSelect, radius, onRadiusChange, buttonLabel = "📍 Select Location" }) {
    const [open, setOpen] = React.useState(false);

    function handleClose(payload) {
      // payload expected: { location: { latitude, longitude } | null, selectedMainText }
      if (payload?.location) {
        const { latitude, longitude } = payload.location;
        onSelect && onSelect({ latitude, longitude, address: payload.selectedMainText || "" });
      }
      setOpen(false);
    }

    return (
      <>
        <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 12 }}>
          {/* <button
            type="button"
            onClick={() => setOpen(true)}
            className="w-full bg-[#23282e] text-white text-xl rounded-lg px-4 py-3 focus:outline-none hover:bg-[#2c3238] transition-colors"
            style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: "center" }}
          >
            <LocationOnIcon style={{ color: selected ? "#FFB800" : "white" }} />
            <span>{selected?.address ? `📍 ${selected.address}` : buttonLabel}</span>
          </button> */}

          {/* optional radius input */}
          {typeof onRadiusChange === "function" && (
            <input
              type="number"
              min="0"
              placeholder="Radius (m)"
              value={radius || ""}
              onChange={e => onRadiusChange(e.target.value)}
              style={{
                width: 120,
                padding: "10px 12px",
                borderRadius: 8,
                border: "1px solid #2c3238",
                background: "#23282e",
                color: "white",
                outline: "none",
              }}
            />
          )}
        </div>

        {/* Use MUI Dialog instead of framer-motion overlay */}
        {/* <Dialog
          open={open}
          onClose={() => setOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{ style: { height: '80vh', overflow: 'hidden' } }}
        >
          <DialogContent style={{ padding: 0, height: '100%' }}>
            <OlaMaps
              onClose={handleClose}
              initialCenter={selected ? { latitude: selected.latitude, longitude: selected.longitude } : undefined}
            />
          </DialogContent>
        </Dialog> */}
      </>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{washer ? 'Edit Washer' : 'Add New Washer'}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Name"
          name="name"
          value={washerData.name}
          onChange={handleChange}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Phone Number"
          name="phone"
          value={washerData.phone}
          onChange={handleChange}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Email"
          name="email"
          value={washerData.email}
          onChange={handleChange}
          margin="normal"
        />
        <TextField
          fullWidth
          select
          label="Location"
          name="location"
          value={washerData.location}
          onChange={handleChange}
          margin="normal"
        >
          {LOCATION_OPTIONS.map((loc) => (
            <MenuItem key={loc} value={loc}>{loc}</MenuItem>
          ))}
        </TextField>
        <TextField
          fullWidth
          label="Address"
          name="address"
          value={washerData.address}
          onChange={handleChange}
          margin="normal"
        />
        <TextField
          fullWidth
          label="LAMP No"
          name="lampNo"
          value={washerData.lampNo}
          onChange={handleChange}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Lamp ID Card"
          name="lampIdCard"
          value={washerData.lampIdCard}
          onChange={handleChange}
          margin="normal"
        />
        <TextField
          fullWidth
          select
          label="Employee Type"
          name="employeeType"
          value={washerData.employeeType}
          onChange={handleChange}
          margin="normal"
        >
          {TYPE_OPTIONS.map((type) => (
            <MenuItem key={type} value={type}>{type}</MenuItem>
          ))}
        </TextField>
        <TextField
          fullWidth
          label="Google Maps URL"
          name="googleMapsUrl"
          value={washerData.googleMapsUrl}
          onChange={handleChange}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Radius"
          name="radius"
          value={washerData.radius}
          onChange={handleChange}
          margin="normal"
        />
        <LocationPicker
          selected={selectedLocation}
          onSelect={(loc) => setSelectedLocation(loc)}
          radius={radius}                // optional - add state if needed
          onRadiusChange={(val) => setRadius(val)}
          buttonLabel="📍 Select Location"
        />
        <TextField
          fullWidth
          select
          label="Work Type"
          name="workType"
          value={washerData.workType}
          onChange={handleChange}
          margin="normal"
        >
          {WORK_TYPE_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>
              {option.charAt(0).toUpperCase() + option.slice(1)}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          fullWidth
          select
          label="Weekoff"
          name="weekoff"
          value={washerData.weekoff}
          onChange={handleChange}
          margin="normal"
        >
          {WEEKOFF_OPTIONS.map((day) => (
            <MenuItem key={day} value={day}>{day}</MenuItem>
          ))}
        </TextField>
        <FormControlLabel
          control={
            <Checkbox
              checked={washerData.onDemand}
              onChange={handleChange}
              name="onDemand"
              color="primary"
            />
          }
          label="On Demand"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={washerData.subscription}
              onChange={handleChange}
              name="subscription"
              color="primary"
            />
          }
          label="Subscription"
        />
        {washerData.subscription && (
          <>
            <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
              Price SUV
            </Typography>
            {SUV_PRICE_LABELS.map((label) => (
              <TextField
                key={`suv-${label}`}
                fullWidth
                label={label}
                name={`suvPrice_${label}`}
                type="number"
                value={washerData.suvPrices[label] || ''}
                onChange={e => handleSuvPriceChange(label, e.target.value)}
                margin="normal"
              />
            ))}
            <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
              Price Hatchback
            </Typography>
            {HATCHBACK_PRICE_LABELS.map((label) => (
              <TextField
                key={`hatchback-${label}`}
                fullWidth
                label={label}
                name={`hatchbackPrice_${label}`}
                type="number"
                value={washerData.hatchbackPrices[label] || ''}
                onChange={e => handleHatchbackPriceChange(label, e.target.value)}
                margin="normal"
              />
            ))}
            <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
              Price Sedan
            </Typography>
            {SEDAN_PRICE_LABELS.map((label) => (
              <TextField
                key={`sedan-${label}`}
                fullWidth
                label={label}
                name={`sedanPrice_${label}`}
                type="number"
                value={washerData.sedanPrices[label] || ''}
                onChange={e => handleSedanPriceChange(label, e.target.value)}
                margin="normal"
              />
            ))}
          </>
        )}
        <TextField
          fullWidth
          select
          SelectProps={{ multiple: true }}
          label="Roles"
          name="roles"
          value={washerData.roles || []}
          onChange={e => {
            const { value } = e.target;
            setWasherData(prev => ({
              ...prev,
              roles: typeof value === 'string' ? value.split(',') : value
            }));
          }}
          margin="normal"
        >
          {['leader', 'washer', 'agent'].map(role => (
            <MenuItem key={role} value={role}>
              {role.charAt(0).toUpperCase() + role.slice(1)}
            </MenuItem>
          ))}
        </TextField>
        {/* Leader Autocomplete */}
        <Autocomplete
          options={leaderOptions}
          getOptionLabel={option => option.name || ''}
          loading={leaderLoading}
          value={leaderOptions.find(opt => opt._id === washerData.leaderId) || null}
          onChange={(event, value) => {
            setWasherData(prev => ({
              ...prev,
              leaderId: value ? value._id : ''
            }));
          }}
          onInputChange={(_, value) => {
            fetchWasherOptions(value, 'leader', setLeaderOptions, setLeaderLoading);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Leader"
              margin="normal"
              fullWidth
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {leaderLoading ? <CircularProgress size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
        {/* Agent Autocomplete */}
        <Autocomplete
          options={agentOptions}
          getOptionLabel={option => option.name || ''}
          loading={agentLoading}
          value={agentOptions.find(opt => opt._id === washerData.agentId) || null}
          onChange={(event, value) => {
            setWasherData(prev => ({
              ...prev,
              agentId: value ? value._id : ''
            }));
          }}
          onInputChange={(_, value) => {
            fetchWasherOptions(value, 'agent', setAgentOptions, setAgentLoading);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Agent"
              margin="normal"
              fullWidth
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {agentLoading ? <CircularProgress size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          {washer ? 'Update' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WasherDialog;
